import React from 'react';
import { motion } from 'framer-motion';
import { Users, BookOpen, Gift, Star } from 'lucide-react';
export function StatsBar() {
  const stats = [{
    icon: Users,
    value: '+500',
    label: 'familias acompañadas'
  }, {
    icon: BookOpen,
    value: '6',
    label: 'Tomos completos'
  }, {
    icon: Gift,
    value: '6',
    label: 'Bonos incluidos'
  }, {
    icon: Star,
    value: '4.9/5',
    label: 'calificación ⭐'
  }];
  return <section className="bg-slate-900 border-y border-slate-800 py-8" data-id="element-346">
      <div className="max-w-6xl mx-auto px-4" data-id="element-347">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8" data-id="element-348">
          {stats.map((stat, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex flex-col items-center text-center" data-id="element-349">
              <stat.icon className="w-8 h-8 text-amber-400 mb-3" data-id="element-350" />
              <div className="text-3xl font-black text-white mb-1" data-id="element-351">
                {stat.value}
              </div>
              <div className="text-sm text-slate-400 font-medium uppercase tracking-wider" data-id="element-352">
                {stat.label}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}